import LeftBodyCardF1 from './leftBodyCardF1/leftBodyCardF1';
import RightBodyCardF1 from './rightBodyCardF1/rightBodyCardF1';
import './bodyCardF1.sass';

/**
 * Componente que representa el cuerpo de una tarjeta de evento de Fórmula 1.
 * Divide visualmente el contenido en dos secciones: izquierda (información general)
 * y derecha (resultados o estado).
 */
export default function BodyCardF1({ data }) {
  return (
    <div className='card-f1__body'>
      {/* renderiza la ubicacion y nombre de la carrera */}
      {!data.race_results.podium && <LeftBodyCardF1 data={data} /> }

      {/* renderiza  el podium o la pista segun sea el caso */}
      <RightBodyCardF1 data={data} />
    </div>
  )
}